export type FieldComponentLoader = () => Promise<any>;

export const APP_COMPONENTS_REGISTRY: Record<string, FieldComponentLoader> = {
  FrameGeneralProfileInfoComponent: () =>
    import('@app/modules/hpc/components/view/frames/general-profile-info/frame-general-profile-info/frame-general-profile-info.component').then(
      (m) => m.FrameGeneralProfileInfoComponent
    ),
};
